import { c as _c } from "react/compiler-runtime";
import coloredMapThumb from "@assets/thumbnails/map-thumbs/colored-map-thumb.png";
import satelliteMapThumb from "@assets/thumbnails/map-thumbs/satellite-map-thumb.png";
import { Box } from "@mui-wrapper";
/** Thumbnail preview of the map style the user will switch to. */
export function MapStyleThumbnail(t0) {
  const $ = _c(4);
  const {
    mapStyle
  } = t0;
  const isColored = mapStyle === "colored";
  const t1 = isColored ? satelliteMapThumb : coloredMapThumb;
  const t2 = isColored ? "Switch to satellite" : "Switch to map";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "38px",
      height: "38px",
      borderRadius: "11px"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== t1 || $[2] !== t2) {
    t4 = <Box component="img" src={t1} alt={t2} sx={t3} />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
}